<template>
  <div class="user-avatar-wrapper">
    <div 
      class="user-avatar" 
      :class="{ 'logged-in': isLogin }"
      @click="handleClick"
    >
      <template v-if="isLogin">
        <!-- 显示手机号后四位或用户名首字母 -->
        <span class="user-info">
          {{ displayName }}
        </span>
        <div class="ff-coins">
              <div class="ff-icon">FF</div>
              <!-- <span>{{ user.coins }}</span> -->
            </div>
      </template>
      <template v-else>
        <!-- 未登录显示灰色小人头像 -->
        <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
        </svg>
      </template>
    </div>
    
    <!-- 用户菜单 -->
    <transition name="menu">
      <div v-if="showMenu && isLogin" class="user-menu" @click.stop>
        <div class="menu-header">
          <div class="menu-name">{{ userName }}</div>
          <div class="menu-phone">{{ userPhone }}</div>
        </div>
        <div class="menu-divider"></div>
        <button class="menu-item logout-item" @click="handleLogout">
          <span>🚪</span>
          <span>退出登录</span>
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'UserAvatar',
  
  data() {
    return {
      showMenu: false,
      isLogin: false,
      userData: null,
    }
  },
  
  computed: {
    // 显示名称逻辑
    displayName() {
      if (!this.userData) return ''
      
      const phone = this.userData.user?.phonenumber
      const name = this.userData.user?.name
      
      // 优先显示手机号后四位
      if (phone && phone.length >= 4) {
        return phone.slice(-4)
      }
      // 其次显示用户名首字母
      if (name) {
        return name.charAt(0).toUpperCase()
      }
      // 默认显示
      return '用户'
    },
    
    userName() {
      return this.userData?.user?.name || '用户(user)'
    },
    
    userPhone() {
      const phone = this.userData?.user?.phonenumber
      if (phone && phone.length === 11) {
        // 格式化手机号：138****1234
        return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      }
      return phone || '未绑定手机号'
    }
  },
  
  mounted() {
    // 初始化登录状态
    this.checkLoginStatus()
    
    // 添加全局点击事件监听
    document.addEventListener('click', this.handleClickOutside)
    
    // 监听storage变化（用于多标签页同步）
    window.addEventListener('storage', this.handleStorageChange)
  },
  
  beforeDestroy() {
    // 清理事件监听
    document.removeEventListener('click', this.handleClickOutside)
    window.removeEventListener('storage', this.handleStorageChange)
  },
  
  methods: {
    // 检查登录状态
    checkLoginStatus() {
      try {
        const currentUser = sessionStorage.getItem('currentUser')
        if (currentUser) {
          this.userData = JSON.parse(currentUser)
          this.isLogin = true
          console.log('用户已登录:', this.userData)
        } else {
          this.isLogin = false
          this.userData = null
        }
      } catch (error) {
        console.error('解析用户数据失败:', error)
        this.isLogin = false
        this.userData = null
      }
    },
    
    // 处理storage变化
    handleStorageChange(e) {
      if (e.key === 'currentUser') {
        this.checkLoginStatus()
      }
    },
    
    // 点击头像
    handleClick(event) {
      event.stopPropagation()
      
      if (this.isLogin) {
        this.showMenu = !this.showMenu
      } else {
        // 未登录跳转到登录页
        this.$router.push('/login')
      }
    },
    
    // 点击外部关闭菜单
    handleClickOutside(event) {
      if (this.showMenu && !this.$el.contains(event.target)) {
        this.showMenu = false
      }
    },
    
    // 退出登录
    async handleLogout() {
      try {
        await this.$confirm('确定要退出登录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        // 清除登录信息
        sessionStorage.removeItem('currentUser')
        
        // 更新状态
        this.isLogin = false
        this.userData = null
        this.showMenu = false
        
        // 提示用户
        this.$message.success('已退出登录')
        
        // 如果当前页面需要登录权限，跳转到首页
        if (this.$route.meta?.requiresAuth) {
          this.$router.push('/')
        }
      } catch (error) {
        // 用户取消操作或出错
        if (error !== 'cancel') {
          console.error('退出登录失败:', error)
          this.$message.error('退出登录失败')
        }
      }
    }
  }
}
</script>

<style scoped>
.user-avatar-wrapper {
  position: relative;
}

.user-avatar {
  /* width: 40px;
  height: 40px;
  background: #f5f5f5; */
  background: var(--light-blue);
  border: 1px solid #e0e0e0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
  font-weight: 600;
  color: #666;
  user-select: none;
  overflow: hidden;
}

.user-avatar:hover {
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transform: scale(1.05);
}

/* 登录后的样式 */
.user-avatar.logged-in {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border: none;
}

.user-avatar.logged-in:hover {
  background: linear-gradient(135deg, #764ba2, #667eea);
}

/* 用户信息文本 */
.user-info {
  font-size: 12px;
  font-weight: 500;
}

/* 用户菜单 */
.user-menu {
  position: absolute;
  top: calc(100% + 12px);
  right: 0;
  background: white;
  border-radius: 8px;
  padding: 8px;
  min-width: 220px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 2000;
  border: 1px solid #e0e0e0;
}

.menu-header {
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.menu-name {
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
  font-size: 16px;
}

.menu-phone {
  font-size: 14px;
  color: #666;
}

.menu-divider {
  height: 1px;
  background: #f0f0f0;
  margin: 8px 0;
}

.menu-item {
  width: 100%;
  text-align: left;
  padding: 12px 16px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 15px;
  color: #333;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 6px;
  font-family: inherit;
}

.menu-item:hover {
  background: #f5f5f5;
}

.menu-item.logout-item:hover {
  background: #ffebee;
  color: #f44336;
}

/* 菜单动画 */
.menu-enter-active,
.menu-leave-active {
  transition: all 0.2s ease;
  transform-origin: top right;
}

.menu-enter,
.menu-leave-to {
  opacity: 0;
  transform: scale(0.95) translateY(-10px);
}

/* 移动端适配 */
@media (max-width: 768px) {
  .user-avatar {
    width: 36px;
    height: 36px;
  }
  
  .user-menu {
    right: -10px;
    min-width: 200px;
  }
  
  .menu-header {
    padding: 12px;
  }
  
  .menu-item {
    padding: 10px 12px;
    font-size: 14px;
  }
}
</style>